import React from "react";
import { Select } from "antd";
import { Division } from "../interfaces";
import { allKnownDivisions, getDivisionName } from "../utils";

// A single-value division filter with a "clear" option to show every division at once.
// For picking exactly one division with no "all divisions" state, see the breadcrumb/Link-based
// division menus on the Stats pages instead (e.g. players/pages/Stats.tsx, goalies/pages/GoalieStats.tsx).
export function DivisionSelect(props: {
  value: Division | undefined;
  onChange: (division: Division) => void;
  onClear: () => void;
}) {
  return (
    <Select
      placeholder="Filter by division"
      allowClear
      value={props.value}
      style={{ width: 180, marginBottom: 16 }}
      onChange={props.onChange}
      onClear={props.onClear}
    >
      {allKnownDivisions.map(d => (
        <Select.Option key={d} value={d}>{getDivisionName(d)}</Select.Option>
      ))}
    </Select>
  );
}
